/**
 * Shared type utilities for UI components
 */

export type FlexibleId = string | number

export function toStringId(id: FlexibleId): string {
  return String(id || '0')
}

export function toNumberId(id: FlexibleId): number {
  if (typeof id === 'number') return id
  const num = Number(id)
  return isNaN(num) ? 0 : num
}
